import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VDStylishEditor = () => {
  const [form, setForm] = useState({
    TopTitleEn: "",
    TopTitleAr: "",
    TopTitleKu: "",

    TopDescEn: "",
    TopDescAr: "",
    TopDescKu: "",

    BottomTitleEn: "",
    BottomTitleAr: "",
    BottomTitleKu: "",

    BottomDescEn: "",
    BottomDescAr: "",
    BottomDescKu: "",
  });

  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(true);

  // Modal
  const [showModal, setShowModal] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);

  const LANGS = ["En", "Ar", "Ku"];
  const SECTION_ID = 13824;

  const resolveUrl = (url) =>
    url?.startsWith("http") ? url : `${API_BASE}${url}`;

  // ============================================================
  // LOAD DATA (EN + AR + KU)
  // ============================================================
  useEffect(() => {
    const load = async () => {
      try {
        const [en, ar, ku] = await Promise.all([
          axios.get(`${API_BASE}/api/VDStylishSection?lang=en`),
          axios.get(`${API_BASE}/api/VDStylishSection?lang=ar`),
          axios.get(`${API_BASE}/api/VDStylishSection?lang=ku`),
        ]);

        setForm({
          TopTitleEn: en.data.topTitle,
          TopTitleAr: ar.data.topTitle,
          TopTitleKu: ku.data.topTitle,

          TopDescEn: en.data.topDesc,
          TopDescAr: ar.data.topDesc,
          TopDescKu: ku.data.topDesc,

          BottomTitleEn: en.data.bottomTitle,
          BottomTitleAr: ar.data.bottomTitle,
          BottomTitleKu: ku.data.bottomTitle,

          BottomDescEn: en.data.bottomDesc,
          BottomDescAr: ar.data.bottomDesc,
          BottomDescKu: ku.data.bottomDesc,
        });

        setImage(en.data.imageUrl);
        setLoading(false);
      } catch (err) {
        console.error("Failed to load Stylish section:", err);
      }
    };

    load();
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // ============================================================
  // SAVE TEXT
  // ============================================================
  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      await axios.put(`${API_BASE}/api/VDStylishSection/${SECTION_ID}`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Stylish section updated!");
    } catch (err) {
      console.error("Save failed", err);
      alert("Failed to save.");
    }
  };

  // ============================================================
  // IMAGE UPLOAD
  // ============================================================
  const handleUpload = async () => {
    if (!uploadFile) return alert("Select a file first.");

    const token = localStorage.getItem("token");

    const fd = new FormData();
    fd.append("Image", uploadFile);

    try {
      await axios.post(
        `${API_BASE}/api/VDStylishSection/${SECTION_ID}/media`,
        fd,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert("Image updated!");
      setShowModal(false);
      window.location.reload();
    } catch (err) {
      console.error("Upload failed", err);
      alert("Failed upload.");
    }
  };

  if (loading) return <p>Loading...</p>;

  // ============================================================
  // RENDER
  // ============================================================
  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">VOYAH DREAM – Stylish Section Editor</h2>

      {/* LANG CARDS */}
      <div className="row">
        {LANGS.map((lang) => (
          <div key={lang} className="col-lg-4 col-md-6 mb-4">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body">
                <h5 className="text-primary">{lang}</h5>

                {/* TOP TITLE */}
                <label className="form-label mt-3">Top Title</label>
                <input
                  className="form-control"
                  name={`TopTitle${lang}`}
                  value={form[`TopTitle${lang}`]}
                  onChange={handleChange}
                />

                {/* TOP DESC */}
                <label className="form-label mt-2">Top Description</label>
                <textarea
                  className="form-control"
                  rows={3}
                  name={`TopDesc${lang}`}
                  value={form[`TopDesc${lang}`]}
                  onChange={handleChange}
                />

                {/* BOTTOM TITLE */}
                <label className="form-label mt-3">Bottom Title</label>
                <input
                  className="form-control"
                  name={`BottomTitle${lang}`}
                  value={form[`BottomTitle${lang}`]}
                  onChange={handleChange}
                />

                {/* BOTTOM DESC */}
                <label className="form-label mt-2">Bottom Description</label>
                <textarea
                  className="form-control"
                  rows={3}
                  name={`BottomDesc${lang}`}
                  value={form[`BottomDesc${lang}`]}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* SAVE BUTTON */}
      <div className="text-end mb-4">
        <button className="btn btn-primary px-4" onClick={handleSave}>
          Save Changes
        </button>
      </div>

      {/* IMAGE BLOCK */}
      <h4 className="mb-3">Image</h4>
      <div className="card shadow-sm border-0 mb-5">
        <div className="card-body">
          {image ? (
            <img
              src={resolveUrl(image)}
              className="rounded w-100 mb-2"
              alt=""
              style={{ objectFit: "cover", maxHeight: "260px" }}
            />
          ) : (
            <p>No image uploaded.</p>
          )}

          <button
            className="btn btn-primary mt-2"
            onClick={() => {
              setUploadFile(null);
              setShowModal(true);
            }}
          >
            Upload / Replace Image
          </button>
        </div>
      </div>

      {/* MODAL */}
      {showModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Upload Image</h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  />
                </div>

                <div className="modal-body">
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={(e) => setUploadFile(e.target.files[0])}
                  />
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-primary" onClick={handleUpload}>
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </div>
  );
};

export default VDStylishEditor;
